import { sessionColor } from '../../../core/constants/transfers';

// Filas "ya transferidas" del tablero de la OPU, derivadas de
// GET /aspiration-sessions/:id/transfer-sessions (decisión 0019). Cada sesión TE
// recibe un color del stack; la fila lleva ese color para subrayarse. El endpoint
// derivado NO trae linaje (donadora/toro) ni remarks — se deja en el embryo tal
// cual (si el backend lo agrega, las columnas se llenan solas); la sesión que se
// está reanudando se enriquece aparte desde su payload assembled (te.transfers).
// `editable` = la preñez sigue `open` ⇒ se puede cambiar receptora o deshacer la TE.
export function buildTransferredRows(opuData) {
    const sessions = opuData?.transfer_sessions || [];
    const out = [];
    sessions.forEach((s, si) => {
        const color = sessionColor(si);
        (s.transfers || []).forEach((t) => {
            const state = t.pregnancy?.state;
            out.push({
                key: `t${t.id}`,
                transferred: true,
                transferId: t.id,
                embryo: t.embryo || {},
                recipient: t.recipient || null,
                pregnancy: t.pregnancy || null,
                farm: s.farm || null,
                sessionId: s.id,
                sessionCode: s.code,
                color,
                editable: !state || state === 'open',
            });
        });
    });
    return out;
}

// Superpone a CADA fila transferida los datos completos de su payload assembled
// (remarks CL/OBS + linaje donadora/toro), que el endpoint derivado de la OPU no
// trae — se obtienen del DTO directo `GET /transfer-sessions/:id` de cada sesión.
// `byId` es un Map transferId→transfer construido con el detalle de TODAS las
// sesiones del tablero, así CL/Obs quedan editables en cualquier sesión (no solo
// la reanudada). Una fila sin match (detalle aún cargando) queda como está ("—").
export function enrichRows(rows, byId) {
    if (!byId || !byId.size) return rows;
    return rows.map((r) => {
        if (!r.transferred) return r;
        const full = byId.get(r.transferId);
        if (!full) return r;
        return {
            ...r,
            embryo: full.embryo || r.embryo,
            recipient: full.recipient || r.recipient,
            remarks: full.remarks || {},
        };
    });
}

// Mezcla las filas del tablero. El "índice" de la OPU (disponibles propias +
// transferidas) va en orden estable por id de embrión y NO muta. Los embriones
// agregados del banco (de otra OPU, source:'bank') se ANEXAN al final en su orden
// de agregado — no se intercalan ni renumeran el índice de la OPU.
export function mergeBoardRows(availableRows, transferredRows) {
    const opu = availableRows.filter((r) => r.source !== 'bank');
    const bank = availableRows.filter((r) => r.source === 'bank');
    const indexed = [...opu, ...transferredRows].sort((a, b) => (a.embryo?.id || 0) - (b.embryo?.id || 0));
    return [...indexed, ...bank];
}
